// ============================================================================
// useAppFlags — flags de funciones (tabla app_settings, se administran desde
// Depuración). Un fetch por montaje; los componentes que gatean UI por flag
// (sidebar, App, pago-modal, purchases) lo usan.
//
// Semántica de defaults mientras carga / si falla la lectura:
//   - facturaScan: ON  (feature ya en producción — no ocultarla por un fallo)
//   - ratings/staff: OFF (add-ons opt-in — no mostrarlas hasta confirmar)
// ============================================================================
import { useEffect, useState } from 'react';
import { getAppSettings, FLAG_FACTURA_SCAN, FLAG_RATINGS, FLAG_STAFF, FLAG_CORTESIAS, FLAG_COMBOS } from '../../api/settings';

export interface AppFlags {
  facturaScan: boolean;
  ratings: boolean;
  staff: boolean;
  cortesias: boolean;
  /** Módulo Combos (oct-2026): opt-in desde Features, como los demás add-ons. */
  combos: boolean;
  /** true cuando ya llegó la respuesta del backend. */
  cargado: boolean;
}

export function useAppFlags(): AppFlags {
  const [flags, setFlags] = useState<AppFlags>({
    facturaScan: true, ratings: false, staff: false, cortesias: false, combos: false, cargado: false,
  });
  useEffect(() => {
    let vivo = true;
    getAppSettings()
      .then(s => {
        if (!vivo) return;
        setFlags({
          facturaScan: s[FLAG_FACTURA_SCAN] !== 'false',
          ratings: s[FLAG_RATINGS] === 'true',
          staff: s[FLAG_STAFF] === 'true',
          cortesias: s[FLAG_CORTESIAS] === 'true',
          combos: s[FLAG_COMBOS] === 'true',
          cargado: true,
        });
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  return flags;
}
